export const COLUMN_HEADER_TOOLTIP = {
  renewalForecast: {
    title: "About Renewal Forecast",
    text: () => (
      <div>
        This forecasts the most likely outcome of the upcoming renewal, based on
        all available data.
        <ul className="list-disc pl-5">
          <li>Growth: The renewal value is expected to increase.</li>
          <li>Flat: The renewal value is expected to stay the same.</li>
          <li>Downscale: The renewal value is expected to decrease.</li>
        </ul>
      </div>
    ),
  },
  deltaMrr: {
    title: "Forecasted Total MRR",
    text: () =>
      "This is the total Monthly Recurring Revenue forecasted for the contract after the renewal. It reflects the new total value, including any growth (upsell) or downscale.",
  },
  deltaArr: {
    title: "Forecasted Total ARR",
    text: () =>
      "This is the total Annual Recurring Revenue forecasted for the contract after the renewal. It reflects the new total value, including any growth (upsell) or downscale.",
  },
  mrr: {
    title: "Current Total MRR",
    text: () =>
      "This is the customer's total Monthly Recurring Revenue as of today. Compare this value to the 'NEW MRR' column to see the forecasted financial change of the renewal.",
  },
  arr: {
    title: "Current Total ARR",
    text: () =>
      "This is the customer's total Annual Recurring Revenue as of today. Compare this value to the 'NEW ARR' column to see the forecasted financial change of the renewal.",
  },
};
